export const adminTools = {
  analytics: {
    title: 'Аналитика',
    summaryTitle: 'Сводка',
    emptyPeriod: 'Нет данных за период',
    chart: {
      zoom: 'Выделить участок',
      zoomBack: 'Сбросить масштаб',
      restore: 'Сбросить график',
      saveImage: 'Сохранить как PNG',
      dataView: 'Таблица данных',
      dataViewClose: 'Закрыть',
      dataViewRefresh: 'Обновить',
      line: 'Линии',
      bar: 'Столбцы',
      stack: 'С накоплением',
      tiled: 'Рядом',
      showPie: 'Круговая диаграмма',
      showBars: 'Столбчатая диаграмма'
    },
    errors: {
      overview: 'Ошибка загрузки обзора',
      retention: 'Ошибка загрузки данных возвращаемости',
      heatmap: 'Ошибка загрузки графика активности',
      topPlayers: 'Ошибка загрузки топ игроков'
    },
    sections: {
      quality: 'Качество матчей',
      funnel: 'Воронка',
      retention: 'Возвращаемость новичков',
      topPlayers: 'Самые активные игроки',
      whenPlay: 'Когда играют',
      modes: 'Режимы матчей'
    },
    funnel: {
      newPlayers: 'Новых игроков',
      playedAtLeastOne: 'Сыграли хотя бы матч',
      conversion: 'Конверсия'
    },
    heatmap: {
      weekdays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
      tzLabel: (utc: string): string => `ваше время, ${utc}`,
      subtitle: (tz: string): string => `Матчи по времени суток (${tz})`,
      empty: 'Нет матчей за период',
      peak: 'Пик',
      busiest: 'Активнее всего',
      quietest: 'Тише всего',
      byWeekday: 'По дням недели',
      matches: (count: number): string => `${count} матчей`
    },
    quality: {
      duration: (minutes: number, seconds: string): string => `${minutes}м ${seconds}с`,
      avgDuration: 'Средняя длительность',
      avgRound: 'Средний раунд',
      finished: 'Доигранные',
      finishedHint: 'матчей завершено',
      completed: 'Завершено',
      aborted: 'Брошено'
    },
    range: {
      days7: '7 дней',
      days30: '30 дней',
      days90: '90 дней',
      custom: 'Произвольно',
      dateFrom: 'Дата начала',
      dateTo: 'Дата конца'
    },
    retention: {
      notStarted: 'Период ещё не начался',
      partial: (pct: string): string => `Промежуточно: период ещё не закончился, ${pct}%`,
      description: 'Какая часть зарегистрировавшихся в этот день вернулась сыграть позже',
      signupDate: 'Дата регистрации',
      newcomers: 'Новичков',
      nextDay: 'Вернулись на след. день',
      week: 'За неделю',
      month: 'За месяц',
      partialNote: '~ — промежуточное значение, период ещё идёт'
    },
    summary: {
      dayLabel: 'Игроки за день',
      dayHint: 'уникальные за последний день',
      weekLabel: 'Игроки за неделю',
      weekHint: 'уникальные за последние 7 дней',
      monthLabel: 'Игроки за месяц',
      monthHint: 'уникальные за последние 30 дней'
    },
    online: {
      title: 'Онлайн',
      errorLoad: 'Ошибка загрузки онлайна',
      players: 'Игроки в матчах',
      site: 'Сайт',
      peak: 'Пик игроков',
      peakSite: 'Пик сайта',
      avgOnline: 'Средний онлайн',
      average: 'Среднее',
      max: 'Максимум',
      matches: 'Матчи',
      empty: 'Нет данных об онлайне за выбранный период',
      chartLabel: 'График онлайна'
    },
    timeseries: {
      title: 'Активность по дням',
      newPlayers: 'Новые игроки',
      matches: 'Матчи',
      activeUsers: 'Уникальные игроки'
    },
    topPlayers: {
      show: 'Показать',
      player: 'Игрок',
      matches: 'Матчей'
    },
    economy: {
      title: 'Экономика',
      includeStaff: 'Учитывать исключённых',
      includeStaffHint: 'Персонал (ADMIN/MODERATOR) и игроки из списка исключений',
      loadError: 'Ошибка загрузки экономики',
      flaggedError: 'Ошибка загрузки подозрительных транзакций',
      journalError: 'Ошибка загрузки журнала игрока',
      summary: {
        credited: 'Начислено',
        debited: 'Списано',
        net: 'Нетто',
        transactions: 'Транзакций',
        players: 'Игроков',
        flagged: 'Flagged'
      },
      daily: {
        title: 'Начислено и списано по дням',
        credited: 'Начислено',
        debited: 'Списано'
      },
      reasons: {
        title: 'По причинам',
        reason: 'Причина',
        credited: 'Начислено',
        debited: 'Списано',
        count: 'Операций',
        names: {
          MATCH_REWARD: 'Награда за матч',
          DAILY_REWARD: 'Ежедневная награда',
          PROMO: 'Промокод',
          CG_SYNC: 'Синхронизация с игрой',
          CASE_BUY: 'Покупка кейса',
          CASE_DUST: 'Пыль из кейса',
          CASE_CURRENCY: 'Валюта из кейса',
          ROULETTE: 'Рулетка',
          ROULETTE_BET: 'Ставка в рулетке',
          ROULETTE_WIN: 'Выигрыш в рулетке',
          ROULETTE_REFUND: 'Возврат ставки',
          SHOP_BUY: 'Покупка в магазине',
          PLAYER_TIP: 'Чаевые игроку'
        } as Record<string, string>
      },
      roulette: {
        title: 'Рулетка',
        bets: 'Ставки',
        wins: 'Выигрыши',
        refunds: 'Возвраты',
        houseEdge: 'House edge',
        houseEdgeHint: '(ставки − возвраты − выигрыши) / (ставки − возвраты)'
      },
      flagged: {
        title: 'Flagged-транзакции',
        empty: 'Нет flagged-транзакций за период'
      },
      excluded: {
        title: 'Исключённые игроки',
        description: 'Их операции не попадают в экономику, пока выключено «Учитывать исключённых»',
        uidLabel: 'Steam UID',
        reasonLabel: 'Причина',
        reasonPlaceholder: 'Необязательно',
        add: 'Исключить',
        remove: 'Вернуть',
        removeAria: (name: string): string => `Вернуть игрока ${name} в аналитику`,
        empty: 'Список исключений пуст',
        player: 'Игрок',
        reason: 'Причина',
        addedBy: 'Добавил',
        date: 'Когда',
        loadError: 'Ошибка загрузки списка исключений',
        addError: 'Не удалось исключить игрока',
        removeError: 'Не удалось вернуть игрока'
      },
      journal: {
        title: 'Журнал игрока',
        uidLabel: 'Steam UID игрока',
        uidPlaceholder: 'Например: 76561198000000000',
        show: 'Показать',
        hint: 'Введите Steam UID, чтобы увидеть операции игрока',
        empty: 'У игрока нет транзакций'
      },
      table: {
        player: 'Игрок',
        amount: 'Сумма',
        balanceAfter: 'Баланс после',
        reason: 'Причина',
        reference: 'Reference',
        date: 'Дата',
        flaggedBadge: 'flagged',
        openPlayer: (name: string): string => `Открыть игрока ${name}`
      },
      pager: {
        prev: 'Назад',
        next: 'Вперёд',
        info: (page: number, total: number, count: number): string => `Стр. ${page} из ${total} · всего ${count}`
      }
    }
  },
  matchSettings: {
    badgeOn: 'Вкл',
    badgeOff: 'Выкл',
    dialogKicker: 'Настройки матча',
    createTitle: 'Создать настройку',
    editTitle: 'Редактировать настройку',
    kicker: 'Конфигурация',
    title: 'Настройки матчей',
    createButton: '+ Создать',
    loadFailedTitle: 'Не удалось загрузить настройки',
    emptyTitle: 'Настроек пока нет',
    emptyDescription: 'Создайте первую настройку матча. CG получит активные настройки при старте матча.',
    form: {
      name: 'Название',
      namePlaceholder: 'Например: ranked_1v1',
      active: 'Активна',
      enabledHint: 'Включена — CG получит при старте матча',
      disabledHint: 'Выключена — не передаётся в CG',
      creating: 'Создаю…',
      saving: 'Сохраняю…'
    },
    deleteDialog: {
      title: 'Удалить настройку?',
      prefix: 'Настройка ',
      suffix: ' будет удалена безвозвратно. CG перестанет получать её при старте матча.',
      deleting: 'Удаляю…'
    },
    errors: {
      load: 'Не удалось загрузить настройки матчей.',
      nameRequired: 'Укажите название настройки.',
      configNotObject: 'Config должен быть JSON-объектом (не массивом и не примитивом).',
      invalidJson: 'Невалидный JSON в поле Config. Проверьте синтаксис.',
      save: 'Не удалось сохранить настройку.',
      delete: 'Не удалось удалить настройку.'
    },
    toasts: {
      created: 'Настройка создана.',
      saved: 'Настройка сохранена.',
      deleted: 'Настройка удалена.'
    },
    table: {
      status: 'Статус',
      updated: 'Обновлено',
      actions: 'Действия',
      edit: 'Правка',
      editAria: (name: string): string => `Редактировать ${name}`,
      deleteAria: (name: string): string => `Удалить ${name}`
    }
  },
  promoCodes: {
    title: 'Промокоды',
    kicker: 'Администрирование',
    createTitle: 'Создать промокод',
    createButton: '+ Создать',
    deactivate: 'Деактивировать',
    noExpiry: 'Без срока',
    paymentAuthor: 'Платёжка',
    loadFailedTitle: 'Не удалось загрузить промокоды',
    emptyTitle: 'Промокодов пока нет',
    emptyDescription: 'Создайте первый промокод. Игроки смогут активировать его через клиент.',
    status: {
      active: 'Активен',
      inactive: 'Деактивирован'
    },
    uses: {
      infinite: '∞ Бесконечно',
      infiniteAria: 'Бесконечно',
      exhausted: 'Исчерпан',
      exhaustedAria: 'Исчерпан',
      remainingAria: (remaining: number): string => `Осталось ${remaining}`
    },
    form: {
      code: 'Код',
      codePlaceholder: 'Например: SUMMER2026',
      untilDate: 'Дата окончания',
      untilDateHint: '(опционально — пусто = без срока)',
      remainingUses: 'Количество активаций',
      remainingUsesHint: '−1 = бесконечно, 0 = выключить, N > 0 = остаток',
      balance: 'Баланс',
      balanceHint: 'Сумма, которая начисляется игроку при активации промокода. Целое число ≥ 0.',
      creating: 'Создаю…'
    },
    deactivateDialog: {
      title: 'Деактивировать промокод?',
      prefix: 'Промокод ',
      suffix:
        ' станет недоступен для активации. Действие необратимо — обратно включить код нельзя. Уже совершённые активации не отменяются.',
      deactivating: 'Деактивирую…'
    },
    activationsDialog: {
      titlePrefix: 'Активации кода ',
      loadFailedTitle: 'Не удалось загрузить активации',
      emptyTitle: 'Активаций пока нет',
      emptyDescription: 'Этот код ещё никто не активировал.',
      next: 'Далее',
      pageSummary: (page: number, totalPages: number, total: number): string =>
        `Страница ${page} / ${totalPages}, всего ${total}`
    },
    errors: {
      load: 'Не удалось загрузить промокоды.',
      loadActivations: 'Не удалось загрузить активации.',
      codeRequired: 'Укажите код промокода.',
      codeTooLong: 'Код не может быть длиннее 64 символов.',
      usesInvalid: 'Количество активаций — целое число ≥ −1 (−1 = бесконечно).',
      balanceInvalid: 'Баланс — целое число ≥ 0.',
      duplicate: 'Промокод с таким кодом уже существует.',
      create: 'Не удалось создать промокод.',
      deactivate: 'Не удалось деактивировать промокод.'
    },
    toasts: {
      created: 'Промокод создан.',
      deactivated: 'Промокод деактивирован.'
    },
    table: {
      author: 'Автор',
      status: 'Статус',
      expiry: 'Окончание',
      activations: 'Активации',
      activated: 'Активировано',
      remaining: 'Осталось',
      created: 'Создан',
      actions: 'Действия',
      activationsAria: (code: string): string => `Активации промокода ${code}`,
      deactivateAria: (code: string): string => `Деактивировать промокод ${code}`
    }
  },
  dedicatedKeys: {
    title: 'Ключи серверов',
    kicker: 'Администрирование',
    subtitle:
      'Пары ключей V2/V3 для dedicated-серверов Dota. Сырые значения не отображаются после сохранения — только название и дата добавления.',
    addTitle: 'Добавить ключ',
    addButton: '+ Добавить',
    loadFailedTitle: 'Не удалось загрузить ключи',
    emptyTitle: 'Ключей пока нет',
    emptyDescription: 'Добавьте первую пару ключей V2/V3 для dedicated-сервера.',
    form: {
      label: 'Название',
      labelPlaceholder: 'Например: host-1',
      keyV2: 'Ключ V2',
      keyV3: 'Ключ V3',
      keysHint: 'После сохранения сами ключи нигде не показываются — останутся только название и дата создания.',
      adding: 'Добавляю…'
    },
    deleteDialog: {
      title: 'Удалить ключ?',
      prefix: 'Ключ ',
      suffix: ' будет удалён безвозвратно. Серверы, использующие эту пару, потеряют доступ.',
      deleting: 'Удаляю…'
    },
    errors: {
      load: 'Не удалось загрузить ключи серверов.',
      labelRequired: 'Укажите название ключа.',
      keysRequired: 'Укажите оба значения — ключ V2 и ключ V3.',
      duplicate: 'Такая пара ключей V2 + V3 уже добавлена.',
      add: 'Не удалось добавить ключ.',
      delete: 'Не удалось удалить ключ.'
    },
    toasts: {
      added: 'Ключ добавлен.',
      deleted: 'Ключ удалён.'
    },
    table: {
      created: 'Создан',
      actions: 'Действия',
      deleteAria: (label: string): string => `Удалить ключ ${label}`
    }
  },
  polls: {
    title: 'Голосования',
    kicker: 'Администрирование',
    createButton: '+ Создать',
    createTitle: 'Новое голосование',
    editTitle: 'Редактирование голосования',
    detailsTitle: 'Статистика голосования',
    loadFailedTitle: 'Не удалось загрузить голосования',
    emptyTitle: 'Голосований пока нет',
    emptyDescription: 'Создайте первое голосование. Активное голосование показывается игрокам на загрузочном экране.',
    status: {
      active: 'Активно',
      inactive: 'Неактивно'
    },
    table: {
      question: 'Вопрос',
      status: 'Статус',
      created: 'Создано',
      activated: 'Активировано',
      deactivated: 'Деактивировано',
      votes: 'Голосов',
      actions: 'Действия',
      none: '—'
    },
    actions: {
      details: 'Статистика',
      edit: 'Правка',
      activate: 'Активировать',
      deactivate: 'Деактивировать',
      detailsAria: (question: string): string => `Статистика голосования: ${question}`,
      editAria: (question: string): string => `Редактировать голосование: ${question}`,
      activateAria: (question: string): string => `Активировать голосование: ${question}`,
      deactivateAria: (question: string): string => `Деактивировать голосование: ${question}`
    },
    form: {
      questionRu: 'Вопрос (RU)',
      questionEn: 'Вопрос (EN)',
      optionsTitle: 'Варианты ответа',
      optionsHint: 'От 2 до 10 вариантов, порядок как в списке. Нужны оба языка.',
      optionRu: (n: number): string => `Вариант ${n} (RU)`,
      optionEn: (n: number): string => `Вариант ${n} (EN)`,
      addOption: '+ Добавить вариант',
      removeOption: 'Убрать',
      removeOptionAria: (n: number): string => `Убрать вариант ${n}`,
      removeBlocked: 'Нельзя убрать: за этот вариант уже есть голоса',
      moveUpAria: (n: number): string => `Поднять вариант ${n}`,
      moveDownAria: (n: number): string => `Опустить вариант ${n}`,
      votesBadge: (count: number): string => `Голосов: ${count}`,
      save: 'Сохранить',
      create: 'Создать',
      saving: 'Сохранение…'
    },
    errors: {
      questionRequired: 'Заполните вопрос на русском и английском',
      optionsCount: 'Нужно от 2 до 10 вариантов',
      optionTextRequired: 'Заполните текст каждого варианта на русском и английском',
      loadDetails: 'Не удалось загрузить голосование',
      create: 'Не удалось создать голосование',
      update: 'Не удалось сохранить голосование',
      activate: 'Не удалось активировать голосование',
      deactivate: 'Не удалось деактивировать голосование',
      conflict: 'Нельзя удалить вариант, за который уже есть голоса'
    },
    toasts: {
      created: 'Голосование создано (неактивно)',
      updated: 'Голосование сохранено',
      activated: 'Голосование активировано',
      deactivated: 'Голосование деактивировано'
    },
    activateDialog: {
      title: 'Активировать голосование?',
      text: 'Голосование станет активным и будет показываться игрокам на загрузочном экране.',
      replaceWarning: 'Текущее активное голосование будет деактивировано.',
      confirming: 'Активация…'
    },
    deactivateDialog: {
      title: 'Деактивировать голосование?',
      text: 'Голосование перестанет показываться игрокам. Статистика сохранится.',
      confirming: 'Деактивация…'
    },
    stats: {
      totalVotes: 'Всего голосов',
      optionsTitle: 'Результаты по вариантам',
      votesAria: (text: string, votes: number, percent: string): string => `${text}: голосов ${votes}, ${percent}`,
      noVotes: 'Пока никто не проголосовал'
    }
  }
};
